export default {
  'component.ratefinish.title': 'Takst',
  'component.ratefinish.heading1': 'Takk for ordren!',
  'component.ratefinish.heading1.description':
    'Takstmannen vil kontakte deg for å ordne ytterligere detaljer. Når taksten er cmplettert, vil assessoren laste opp tariffinfo-dokumentet, og du finner all tilgjengelig informasjon her. Klikk på OK for å gå tilbake til hovedsiden. ',
  'component.ratefinish.okay': 'Greit',
  'component.ratefinish.viewdetails': 'Vis detaljer',
};
